
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './initpagee6uxsk.scss';






const Pinitpagee6uxsk = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id68abd8cd60a29c1eab0fc41e" >

      <div id="iwt62" className="">
      
      <div id="icxk" className="">
      
      <div id="iin8q" className="">
      
      <div id="ify1g" className="">
      
      <img
        className=""
        id="ip8xoj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimermwqde.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="irf9e1" className="">
      
        <LoftyDropdownComponent
          id="i6m8dn"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i74lhz" className="gjs-dropdown-menu-trigger ">
<>
          Menu
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="inwtg3" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i40ovr"
          href="#"
        >
          
    <div id="i2nkmz" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iogfah"
          href={`/menu`}
        >
          
    <div id="i2no8t" className="">
    <>Menu</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iprzux"
          href={`/contact`}
        >
          
    <div id="irz8yv" className="">
    <>Contacto</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      </div>
      
      <div id="i95gii" className="">
      
        <a
          target=""
          className=""
          id="ipz0pg"
          href="#"
        >
          
    <div id="i2vvpe" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwg0nn"
          href={`/menu`}
        >
          
    <div id="idbyah" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv95sw"
          href="/contact"
        >
          
    <div id="icq2ek" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1xxv" className="">
      
      <div id="inwavh" className="">
      
      <div className="" id="iybdaj">
        <>Un rincón de Italia en tu ciudad</>
      </div>
      
      <div className="" id="i9ylo6">
        <>¡Ven y déjate conquistar por nuestra cocina!</>
      </div>
      
      </div>
      
      <div id="iz083u" className="">
      
        <a
          target=""
          className=""
          id="irhnqj"
          href={`/menu`}
        >
          
    <div id="iptqks" className="">
    <>Ver Menu</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="inak" className="">
      
      <div className="" id="ihc7">
        <>Benvenuti a Vita</>
      </div>
      
      </div>
      
      <div id="i062" className="">
      
      <div id="iwoij" className="">
      
      <img
        className=""
        id="ijp7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb6ycoq5.png"
        alt="undefined"
      />
      
      <div className="" id="ip03r">
        <>En Vita te invitamos a disfrutar de una experiencia culinaria auténtica, donde cada plato cuenta una historia. Con recetas tradicionales, ingredientes frescos y el verdadero sabor de Italia, nuestro restaurante es el lugar perfecto para compartir una comida en familia, una cena romántica o una celebración especial.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ivp9rg" className="">
      
      <div id="iyczei" className="">
      
      <div id="invw4j" className="">
      
      <div className="" id="inbsh">
        <>Tu Pizza favorita hecha en el momento</>
      </div>
      
      <img
        className=""
        id="ir2ou"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb6zv51f.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="idi9lr" className="">
      
      <img
        className=""
        id="i3ejze"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb6zwvn7.png"
        alt="undefined"
      />
      
      <div className="" id="i4ymkn">
        <>Con Ingredientes frescos y la mejor calidad</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihh0r" className="">
      
      <div id="i0ec4" className="">
      
      <div id="ixd8l" className="">
      
      </div>
      
      <div id="i4o5j" className="">
      
      <div className="" id="i2zef">
        <>Síguenos en Instagram para ver fotos tomadas por nuestras clientes.</>
      </div>
      
      </div>
      
      <div id="iuaxf" className="">
      
      <div id="ii2un" className="">
      
      </div>
      
      <div id="ir24l" className="">
      
      </div>
      
      <div id="ix4wj" className="">
      
      </div>
      
      </div>
      
      <div id="iahz7" className="">
      
      <div id="iwt9t" className="">
      
      </div>
      
      <div id="i6zkl" className="">
      
      </div>
      
      <div id="inb5g" className="">
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2061" className="">
      
      <div id="iq0b9" className="">
      
      </div>
      
      <div id="iizhn" className="">
      
      <div id="izaiq" className="">
      
      <img
        className=""
        id="ikodtq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimern109r.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i0hei" className="">
      
        <a
          target=""
          className=""
          id="iu98r"
          href="#"
        >
          
    <div id="ixdpz" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iam0d"
          href="#"
        >
          
    <div id="inoxt" className="">
    <>Menu</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iigdg"
          href="#"
        >
          
    <div id="iocf4" className="">
    <>Contacto</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="icv2g" className="">
      
      </div>
      
      <div id="ics7l" className="">
      
        <a
          target=""
          className=""
          id="i7f4f"
          href="#"
        >
          
      <img
        className=""
        id="i5u1b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qgrj.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="ivriv"
          href="#"
        >
          
      <img
        className=""
        id="i0mqz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70qw8z.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="icv2s"
          href="#"
        >
          
      <img
        className=""
        id="ixnni"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb70r22p.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="ihhz2" className="">
      
      </div>
      
      </div>
      
      <div id="il1wo" className="">
      
      <div className="" id="i732cg">
        <>Copyright © 2025.Vita . Todos derechos reservados</>
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinitpagee6uxsk);
  